module.exports = __webpack_public_path__ + "search-global.svg?b0faa13c2527673e2d8dbc068400f50c";


//////////////////
// WEBPACK FOOTER
// ./src/css_profile/img/icons/search-global.svg
// module id = 1864
// module chunks = 0